<!--suppress ALL -->

<template>
  <el-dialog top="10px"
             width="340px"
             :visible.sync="isVisible"
             :close-on-click-modal="false" :close-on-press-escape="false" :fullscreen="false" :append-to-body="true"
             title="二维码">
    <div style="width: 100%; height: 100%; text-align: center">
      <div style="width: 100%;text-align: center; margin-bottom: 30px">{{ title }}</div>
      <div v-if="items.length > 1" style="text-align: left; margin-bottom: 5px">选择应用</div>
      <el-select v-if="items.length > 1" v-model="select_item_id" size="large" class="full" @change="createQrcode">
        <el-option v-for="item in items" :value="item.itemId" :key="item.itemId" :label="item.name"></el-option>
      </el-select>
      <img v-if="qrcode" :src="qrcode" width="300px" height="300px">

      <div style="display: flex"><el-button v-if="url" type="primary" size="small" style="margin-top: 40px" @click="copy_url">复制链接</el-button> <el-button v-if="qrcode" type="primary" size="small" style="margin-top: 40px" @click="download">下载图片</el-button></div>
    </div>
  </el-dialog>
</template>


<script>

export default {
  name: 'Qrcode',
  data() {
    return {
      isVisible: false,
      qrcode: '',
      title: '',
      select_item_id: '',
      items: [],
    }
  },

  components: {},
  methods: {
    create(title, item_id, type, target_id) {
      this.title = title
      this.isVisible = true
      let t = this;
      this.$post(
          {
            context: t,
            path: '/app/qrcode/',
            params: {
              item_id: item_id,
              type: type,
              target_id: target_id,
            },
            success: function (data) {
              t.qrcode = data.qrcode
              t.url = data.url
            }
          }
      )
    },

    createSelectApp(title, type, target_id) {
      this.title = title
      this.isVisible = true
      this.qrcode = ''
      this.url = ''
      this.items = []
      this.select_item_id = ''
      this.type = type;
      this.target_id = target_id;
      this.getItemList();
    },

    getItemList: function () {
      let t = this;
      this.$get(
          {
            context: t,
            path: '/app/list/',
            params: {
              qrcode: 1
            },
            success: function (data) {
              t.items = data.items;
              if (data.items.length  == 1){
                t.select_item_id = data.items[0].itemId
                t.createQrcode()
              }
            }
          }
      )
    },
    createQrcode() {
      let t = this;
      this.$post(
          {
            context: t,
            path: '/app/qrcode/',
            params: {
              item_id: this.select_item_id,
              type: this.type,
              target_id: this.target_id,
            },
            success: function (data) {
              t.qrcode = data.qrcode
              t.url = data.url
            }
          }
      )
    },

    createImage(title, image) {
      this.title = title
      this.isVisible = true
      this.qrcode = image;
    },

    download(){
      window.location.href = this.qrcode
    },
    copy_url(){
      try {
        navigator.clipboard.writeText(this.url);
        this.$message({
          type: 'success',
          message: '复制成功!'
        });
      } catch (err) {
      }
    },
  }

}
</script>
<style scoped >
@import '../assets/global.css';

.attach-container {
  display: flex;
  flex-wrap: wrap; /* 关键属性：允许自动换行 */
  gap: 10px; /* 可选：设置项目之间的间距 */
}

.attach-item {
  flex: 1 1 auto; /* 项目可以伸缩 */
  min-width: 250px; /* 设置最小宽度，防止项目过小 */
  max-width: 250px;
  padding: 10px;
  box-sizing: border-box;
  text-align: center;
}

</style>
